<template>
    <div class="endoscopyBox">
        <div class="endoscopyCon">
            <indexTitle :title="dataInfo.moduleTitle" @goMore="goMore"></indexTitle>
            <div class="listBox">
                <div @click="$openUrl(item.jump_url, false)" v-for="item in dataInfo.list" :key="item.id"
                    class="listItem">
                    <img class="centerImag" :src="item.cover" alt="" />
                    <div class="footText">{{ item.desc }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import indexTitle from "./indexTitle.vue"
export default {
    components: {
        indexTitle,

    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    is_show: 0,
                    list: [],
                    moduleTitle: '',
                }
            },
        },
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        goMore() {
            let lang = this.$i18n.locale == 'zh' ? 'cn' : 'en'
            this.$router.push({
                path: `/${lang}/systemsList`,
                query: {
                    id: 'bc7b8f90-c1f4-11ef-bcc2-cb1625e53d0d',
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.endoscopyBox {
    background: #fff;
    margin-top: 116px;

    .endoscopyCon {
        width: 1200px;
        margin: auto;

        .listBox {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;

            .listItem {
                width: 585px;
                margin-bottom: 30px;
                cursor: pointer;

                &:nth-last-child(1) {
                    margin-bottom: 0px;
                }

                &:nth-last-child(2) {
                    margin-bottom: 0px;
                }

                .centerImag {
                    width: 100%;
                    height: 300px;
                    object-fit: cover;
                }

                .footText {
                    margin-top: 28px;
                    font-size: 24px;
                    color: #000000;
                    line-height: 24px;
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {
    .endoscopyBox {
        background: #fff;
        margin-bottom: 50px;

        .endoscopyCon {
            width: 100%;
            margin: auto;

            .listBox {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;

                .listItem {
                    width: 100%;
                    margin-bottom: 30px;

                    .centerImag {
                        width: 100%;
                        height: 300px;
                        display: block;
                        object-fit: cover;
                    }
                }
            }
        }
    }

}
</style>